import { ApiProblem, NetworkError } from '@acme/api-client'
import { useI18n } from 'vue-i18n'

// Standard UI message for any API failure (the backend already decided what the user may do).
export function useErrorMessage() {
  const { t } = useI18n()

  return (error: unknown): { title: string; detail?: string; reference?: string } => {
    if (error instanceof NetworkError) {
      return { title: t('shell.errors.network') }
    }

    if (error instanceof ApiProblem) {
      const reference = error.correlationId
      if (error.isValidation) return { title: t('shell.errors.validation'), reference }
      if (error.status === 400) return { title: t('shell.errors.validation'), detail: error.title, reference }
      if (error.isForbidden) return { title: t('shell.errors.forbidden'), reference }
      if (error.isNotFound) return { title: t('shell.errors.notFound'), reference }
      if (error.isConflict) return { title: t('shell.errors.conflict'), detail: error.title, reference }
      return { title: t('shell.errors.server'), reference }
    }

    return { title: t('shell.errors.generic') }
  }
}

// Retry only transient failures (network / 5xx); 4xx are answers, not glitches.
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiProblem && error.status < 500) {
    return false
  }

  return failureCount < 2
}
